export { default } from './BensServicosBuscaLojas';
